<template>
  <div class="meeting-card">
    <div class="left">
      <div class="time">
        {{ new Date(item.start_time * 1000).format('hh:mm') }}-{{
          new Date(item.end_time * 1000).format('hh:mm')
        }}
      </div>
      <div class="state-wrap">
        <span class="state" :class="'state-' + item.live_status">
          <span v-if="item.live_status == 1">未开始</span>
          <span v-else-if="item.live_status == 2" class="living">
            <span class="primary-color">直播中</span>
          </span>
          <span v-else>
            <span>已结束</span>
          </span>
        </span>
      </div>
    </div>
    <div class="line"></div>
    <div class="main">
      <div class="main-line"></div>
      <div class="main-content">
        <div>
          <span class="type">班会</span>
          <span class="title">
            <span>{{ item.meeting_name }}</span>
          </span>
          <div class="subtitle" v-if="item.class_teacher_name">
            <span class="meeting-teacher">
              {{ item.class_teacher_name }}
            </span>
            <span class="divider" v-if="showTime">|</span>
            <span class="meeting-teacher" v-if="showTime">
              {{ item.start_time | tsFormatDate }}
            </span>
          </div>
        </div>
      </div>
      <div class="live-state">
        <template>
          <span v-if="item.live_status != 3" class="period-living" @click.stop="goToPlay(item, 5)">
            进入直播间
          </span>
          <!--          <span-->
          <!--            v-if="item.live_status == 1"-->
          <!--            class="period-living disabled"-->
          <!--            :style="{ cursor: 'not-allowed' }"-->
          <!--          >-->
          <!--            进入直播间-->
          <!--          </span>-->
          <!--              回放生成-->
          <span
            v-if="item.live_status == 3 && item.bjy_encode_status == 1"
            @click.stop="goToPlay(item, 5)"
          >
            查看回放
          </span>
          <!--              回放未生成-->
          <span
            v-if="item.live_status == 3 && item.bjy_encode_status != 1"
            class="disabled"
            :style="{ cursor: 'not-allowed' }"
          >
            查看回放
          </span>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MeetingCard',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    showTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    //直播，回放
    goToPlay(item, type) {
      this.$emit('goToPlay', item, type);
    },
  },
};
</script>
<style lang="scss" scoped>
.meeting-card {
  display: flex;
  //&:last-child {
  //  .line::after {
  //    display: none;
  //  }
  //  .main {
  //    margin-bottom: 0;
  //  }
  //}
  .left {
    margin-right: 16px;
    margin-top: 18px;
    width: 115px;
  }
  .main {
    flex: 1;
    display: flex;
    align-items: center;
    margin-bottom: 35px;
    border: 1px solid #e6e6e6;
    border-left: none;
    padding: 18px 16px 18px 18px;
    position: relative;
  }
  .main-line {
    position: absolute;
    height: 100%;
    width: 4px;
    left: 0;
    top: 0;
    background: #f39b10;
  }
  .main-content {
    flex: 1;
  }
  .time {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    height: 22px;
    line-height: 22px;
    display: flex;
    justify-content: flex-end;
  }
  .line {
    position: relative;
    width: 10px;
    margin: 0 24px 0 0;

    &::before {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      box-sizing: border-box;
      border: 2px solid #f39b10;
      border-radius: 50%;
      background: #fce6c3;
      z-index: 1;
      top: 24px;
    }
    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 100%;
      box-sizing: border-box;
      border-left: 2px dashed #dadada;
      left: 4px;
      top: 30px;
    }
  }
  .type {
    font-size: 12px;
    color: $primary-color;
    background: $primary-color-light;
    padding: 3px 6px;
    border-radius: 4px;
    margin-right: 8px;
    line-height: 16px;
    vertical-align: middle;
  }
  .state-wrap {
    display: flex;
    justify-content: flex-end;
    padding-top: 2px;
  }
  .state {
    font-size: 14px;
    color: #999999;
    padding-left: 20px;
    background-image: url('~@/assets/images/calendar/end@2x.png');
    background-repeat: no-repeat;
    background-size: 16px 16px;
    background-position: left center;
  }
  .state-1 {
    background-image: url('~@/assets/images/calendar/wait@2x.png');
  }
  .state-2 {
    background-image: url('~@/assets/images/calendar/living@2x.png');
  }
  .living {
    color: $primary-color;
  }
  .title {
    font-size: 14px;
    vertical-align: middle;
    color: #333333;
    font-weight: 400;
  }
  .subtitle {
    color: #999999;
    margin-top: 8px;
    .meeting-teacher {
      vertical-align: middle;
    }
    .divider {
      vertical-align: middle;
      padding: 0 5px;
      font-size: 14px;
    }
  }
  .subtitle-line {
    margin: 0 8px;
    color: #d8d8d8;
  }
  .live-state {
    display: flex;
    position: relative;
    span {
      font-size: 14px;
      border: 1px solid #bfbfbf;
      cursor: pointer;
      border-radius: 19px;
      margin-left: 10px;
      padding: 7px 20px;
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        border-color: $primary-color;
        color: $primary-color;
      }
      &.disabled {
        color: #333333;
        background: #f5f5f5;
        opacity: 0.5;
        cursor: not-allowed;

        &:hover {
          background: #f5f5f5;
          color: #333333;
          cursor: default;
          border-color: #bfbfbf;
        }
      }
    }
    .more {
      width: 36px;
      padding: 0;
      text-align: center;
      line-height: 34px;
      background: url('~@/assets/images/calendar/more@2x.png') no-repeat center center/16px 4px;
    }
    .more-panel {
      position: absolute;
      right: 0;
      top: 40px;
      width: 128px;
      padding: 4px 0;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    }
    .more-item {
      height: 36px;
      padding-left: 12px;
      line-height: 36px;
      cursor: pointer;
      &:hover {
        background: $primary-color-light;
        color: $primary-color;
      }
    }
  }
}
</style>
